import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';

Vue.use(Router)

const routes = [
  {
    path: '/course/list',
    name: 'Sqjspx2026ListPage',
    component: () => import('@/pages/sqjspx2026/list.vue'),
    meta: {
      showHeader: false,
      showFooter: false,
      requireAuth: false
    }
  },
  {
    path: '/course/detail1',
    name: 'Sqjspx2026DetailPage',
    component: () => import('@/pages/sqjspx2026/detail.vue'),
    meta: {
      showHeader: false,
      showFooter: false,
      requireAuth: false
    }
  },
  {
    path: '/course/detail',
    name: 'Sqjspx2026Detail2Page',
    component: () => import('@/pages/sqjspx2026/detail2.vue'),
    meta: {
      showHeader: false,
      showFooter: false,
      requireAuth: false
    }
  }
]

const router = new Router({
  mode: 'history',
  base: '/',
  routes: routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || '2026年暑期教师培训'
  await store.dispatch('checkLogin')
  const isLogin = store.state.account.isLogin
  if (to.path === '/login') {
    if (isLogin) {
      const type = store.state.account.type
      if (type === 100) {
        next({
          path: '/course/list',
          query: { redirect: to.fullPath }
        })
      }
    } else {
      next()
      return
    }
  }
  if (to.meta.requireAuth && !isLogin) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

export default router
